import axios from "axios";
import Config from "../../Config";

class ProfileRequests {
  static baseUrl = `${Config.backendDomain}`;
  static getHeaders() {
    return {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ProfileRequests.getToken()}`,
      },
    };
  }

  static getToken() {
    return localStorage.getItem("dealboxx_token");
  }

  static async updateProfileData(payload) {
    const response = await axios.post(
      `${ProfileRequests.baseUrl}vendor/brand/info`,
      payload,
      ProfileRequests.getHeaders()
    );
    return response?.data || null;
  }

  static async changeProfilePassword(payload) {
    const response = await axios.post(
      `${ProfileRequests.baseUrl}vendor/change/password`,
      payload,
      ProfileRequests.getHeaders()
    );
    return response?.data || null;
  }
}
export default ProfileRequests;
